import type {MakeTextEditableLoadingPanelProps} from '@Panels/make-text-editable-loading-panel/make-text-editable-loading-panel.types';

export const PENDING_DESIGN_READY_GROWL_KEY = 'pending-design-ready';
export const PENDING_DESIGN_ERROR_GROWL_KEY = 'pending-design-error';
export const PENDING_DESIGN_READY_GROWL_INTERVAL_MS = 3000;

export enum PendingDesignPollStatus {
  READY = 'ready',
  TIMED_OUT = 'timedOut',
}

export interface PendingDesignReady {
  status: PendingDesignPollStatus.READY;
  posterHashedId: string;
}

/** The poll budget ran out but the job has not failed: it may still finish server-side. */
export interface PendingDesignTimedOut {
  status: PendingDesignPollStatus.TIMED_OUT;
}

export type PendingDesignPollOutcome = PendingDesignReady | PendingDesignTimedOut;

/** What each product (Editable text, Editable image) plugs into the shared editor-tab reveal. */
export interface PendingDesignRevealConfig {
  jobId: string;
  /** The overlay backdrop while the job runs, and the canvas fallback when it fails. */
  originalImageUrl: string | null;
  loadingCopy: MakeTextEditableLoadingPanelProps;
  readyGrowlText: string;
  failureGrowlText: string;
  /** Polls within its own budget; resolves READY or TIMED_OUT, rejects when the job failed. */
  pollJob: (jobId: string) => Promise<PendingDesignPollOutcome>;
  showFeedback: (posterHashedId: string) => void;
  /** Used when the job finished on a different poster than the open one. */
  getPosterUrlWithFeedback: (posterHashedId: string) => string;
}
